module.exports = __webpack_public_path__ + "static/img/game-logo-bet.7ecd4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-bet.png
// module id = 4wjp
// module chunks = 0 1 2 3 4 5 6